import './App.css';
import { Provider } from 'react-redux';
import { store, persistor} from './store';
import Routes from './Routes';
import { PersistGate } from 'redux-persist/integration/react'
import 'react-datepicker/dist/react-datepicker.css';
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          <Routes/>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
